// ===================================================
// src/components/Planning/utils/planningHelpers.js - Updated with Production Target
// ===================================================

/**
 * Get default form data structure
 */
export const getDefaultFormData = () => ({
  // Basic
  actual_date: '',
  target_total: 0,
  production_target_total: 0,

  // Sales by region/product/size
  sales_us_cityplay_m: 0,
  sales_us_cityplay_l: 0,
  sales_us_20_m: 0,
  sales_us_20_l: 0,
  sales_uk_cityplay_m: 0,  // Keep field name for DB compatibility but display as EU
  sales_uk_cityplay_l: 0,
  sales_uk_20_m: 0,
  sales_uk_20_l: 0,

  // Manufacturing by region/product/size
  manufacturing_us_cityplay_m: 0,
  manufacturing_us_cityplay_l: 0,
  manufacturing_us_20_m: 0,
  manufacturing_us_20_l: 0,
  manufacturing_uk_cityplay_m: 0,  // Keep field name for DB compatibility but display as EU
  manufacturing_uk_cityplay_l: 0,
  manufacturing_uk_20_m: 0,
  manufacturing_uk_20_l: 0,

  // Stock by region/product/size
  stock_us_cityplay_m: 0,
  stock_us_cityplay_l: 0,
  stock_us_20_m: 0,
  stock_us_20_l: 0,
  stock_uk_cityplay_m: 0,  // Keep field name for DB compatibility but display as EU
  stock_uk_cityplay_l: 0,
  stock_uk_20_m: 0,
  stock_uk_20_l: 0,

  // Amazon stock - NEW
  stock_us_amazon: 0,
  stock_eu_amazon: 0,

  // Shipment durations
  china_us: 20,
  china_uk: 15,  // Keep field name for DB compatibility but display as EU
  us_customer: 7,
  uk_customer: 5  // Keep field name for DB compatibility but display as EU
});

/**
 * Calculate totals from form data
 */
export const calculateTotals = (formData) => {
  const salesTotal =
    (formData.sales_us_cityplay_m || 0) +
    (formData.sales_us_cityplay_l || 0) +
    (formData.sales_us_20_m || 0) +
    (formData.sales_us_20_l || 0) +
    (formData.sales_uk_cityplay_m || 0) +
    (formData.sales_uk_cityplay_l || 0) +
    (formData.sales_uk_20_m || 0) +
    (formData.sales_uk_20_l || 0);

  const manufacturingTotal =
    (formData.manufacturing_us_cityplay_m || 0) +
    (formData.manufacturing_us_cityplay_l || 0) +
    (formData.manufacturing_us_20_m || 0) +
    (formData.manufacturing_us_20_l || 0) +
    (formData.manufacturing_uk_cityplay_m || 0) +
    (formData.manufacturing_uk_cityplay_l || 0) +
    (formData.manufacturing_uk_20_m || 0) +
    (formData.manufacturing_uk_20_l || 0);

  const stockTotal =
    (formData.stock_us_cityplay_m || 0) +
    (formData.stock_us_cityplay_l || 0) +
    (formData.stock_us_20_m || 0) +
    (formData.stock_us_20_l || 0) +
    (formData.stock_uk_cityplay_m || 0) +
    (formData.stock_uk_cityplay_l || 0) +
    (formData.stock_uk_20_m || 0) +
    (formData.stock_uk_20_l || 0);

  const stockTotalWithAmazon = stockTotal +
    (formData.stock_us_amazon || 0) +
    (formData.stock_eu_amazon || 0);

  return { salesTotal, manufacturingTotal, stockTotal, stockTotalWithAmazon };
};

/**
 * Populate form data from existing day data
 */
export const populateFormDataFromDay = (dayData) => {
  if (!dayData) return getDefaultFormData();

  const formData = getDefaultFormData();

  // Basic fields
  formData.actual_date = dayData.date || '';
  formData.target_total = dayData.sales?.target_total || 0;
  formData.production_target_total =
    dayData.manufacturing?.plan_target_total ||
    dayData.production_target_total ||
    0;


  // Extract detailed data if available
  if (dayData.detailed) {
    // Sales
    formData.sales_us_cityplay_m = dayData.detailed.sales_us_cityplay_m || 0;
    formData.sales_us_cityplay_l = dayData.detailed.sales_us_cityplay_l || 0;
    formData.sales_us_20_m = dayData.detailed.sales_us_20_m || 0;
    formData.sales_us_20_l = dayData.detailed.sales_us_20_l || 0;
    formData.sales_uk_cityplay_m = dayData.detailed.sales_uk_cityplay_m || 0;
    formData.sales_uk_cityplay_l = dayData.detailed.sales_uk_cityplay_l || 0;
    formData.sales_uk_20_m = dayData.detailed.sales_uk_20_m || 0;
    formData.sales_uk_20_l = dayData.detailed.sales_uk_20_l || 0;

    // Manufacturing
    formData.manufacturing_us_cityplay_m = dayData.detailed.manufacturing_us_cityplay_m || 0;
    formData.manufacturing_us_cityplay_l = dayData.detailed.manufacturing_us_cityplay_l || 0;
    formData.manufacturing_us_20_m = dayData.detailed.manufacturing_us_20_m || 0;
    formData.manufacturing_us_20_l = dayData.detailed.manufacturing_us_20_l || 0;
    formData.manufacturing_uk_cityplay_m = dayData.detailed.manufacturing_uk_cityplay_m || 0;
    formData.manufacturing_uk_cityplay_l = dayData.detailed.manufacturing_uk_cityplay_l || 0;
    formData.manufacturing_uk_20_m = dayData.detailed.manufacturing_uk_20_m || 0;
    formData.manufacturing_uk_20_l = dayData.detailed.manufacturing_uk_20_l || 0;

    // Stock
    formData.stock_us_cityplay_m = dayData.detailed.stock_us_cityplay_m || 0;
    formData.stock_us_cityplay_l = dayData.detailed.stock_us_cityplay_l || 0;
    formData.stock_us_20_m = dayData.detailed.stock_us_20_m || 0;
    formData.stock_us_20_l = dayData.detailed.stock_us_20_l || 0;
    formData.stock_uk_cityplay_m = dayData.detailed.stock_uk_cityplay_m || 0;
    formData.stock_uk_cityplay_l = dayData.detailed.stock_uk_cityplay_l || 0;
    formData.stock_uk_20_m = dayData.detailed.stock_uk_20_m || 0;
    formData.stock_uk_20_l = dayData.detailed.stock_uk_20_l || 0;

    // Amazon stock
    formData.stock_us_amazon =
      dayData.stock?.us_amazon ||
      dayData.detailed?.stock_us_amazon ||
      0;
    formData.stock_eu_amazon =
      dayData.stock?.eu_amazon ||
      dayData.detailed?.stock_eu_amazon ||
      0;

    // Shipment durations
    formData.china_us = dayData.detailed.china_us || 30;
    formData.china_uk = dayData.detailed.china_uk || 35;
    formData.us_customer = dayData.detailed.us_customer || 3;
    formData.uk_customer = dayData.detailed.uk_customer || 2;
  }

  return formData;
};

// 📆 Generate a basic monthly plan (helper for GeneratePlanModal)
export function generateMonthlyPlan(startDate, daysCount, forecast) {
  const start = new Date(startDate);
  const plan = [];

  for (let i = 0; i < daysCount; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    plan.push({
      date: date.toISOString().split('T')[0],
      forecast
    });
  }

  return plan;
}

/**
 * Common modal styles
 */
export const commonModalStyles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow:
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  inputStyle: (hasError) => ({
    width: '100%',
    padding: '0.5rem 0.75rem',
    border: hasError ? '1px solid #dc2626' : '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.875rem'
  }),
  smallInputStyle: {
    width: '100%',
    padding: '0.375rem 0.5rem',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    fontSize: '0.75rem'
  },
  cancelButtonStyle: {
    padding: '0.5rem 1rem',
    backgroundColor: '#f3f4f6',
    color: '#374151',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer'
  },
  saveButtonStyle: (loading) => ({
    padding: '0.5rem 1.5rem',
    backgroundColor: loading ? '#9ca3af' : '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: loading ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  })
};
